class StringUtils
{
    static stripHtml = (str: string): string => {
        return str.replace(/<[^>]*>/g, '');
    }

    static isHtmlEmpty = (str: string): boolean => {
        return (StringUtils.stripHtml(str).trim().length === 0);
    }

}

export default StringUtils;
